import { render, staticRenderFns } from "./TgStars.vue?vue&type=template&id=2a3b8c5c&"
import script from "./TgStars.vue?vue&type=script&lang=js&"
export * from "./TgStars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports